var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarYellowFull({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3608 0.706163C12.4608 0.453072 12.819 0.453073 12.9189 0.706164L15.8623 8.16024C15.9075 8.27479 16.0182 8.35006 16.1413 8.35006L24.436 8.35006C24.7183 8.35006 24.8443 8.70449 24.6254 8.88272L17.7494 14.4799C17.6513 14.5597 17.6138 14.6925 17.6557 14.8119L20.5757 23.131C20.6721 23.4058 20.3601 23.643 20.1212 23.4766L12.8113 18.3857C12.7083 18.314 12.5715 18.314 12.4684 18.3857L5.15857 23.4766C4.91966 23.643 4.60763 23.4058 4.70405 23.131L7.62402 14.8119C7.66591 14.6925 7.62844 14.5597 7.53034 14.4799L0.654362 8.88272C0.43542 8.70449 0.561443 8.35006 0.843753 8.35006L9.13844 8.35006C9.26159 8.35006 9.37224 8.27479 9.41747 8.16024L12.3608 0.706163Z",
    fill: "#F8CF46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarYellowFull);
export default __webpack_public_path__ + "static/media/starYellowFull.7fcf5e377b56426d5e3a5ffedad100ea.svg";
export { ForwardRef as ReactComponent };